import * as d3 from 'd3-selection'
import caret from '../caret.js'
import items from './items.js'
import input from './input.js'
import pointerHandler from '../pointer-handler.js'
import * as interactions from '../interactions.js'

var insert = function (selection, clazz, render) {
  selection.each(function (data) {
    var n = d3.select(this)
              .selectAll('.' + clazz)
              .data(function (d) {
                return render ? [d] : []
              })

    n.enter()
     .append('div')
       .attr('class', clazz)
       .merge(n)
       .html(render)

    n.exit().remove()
  })
}

var draw = function (selection) {
  selection.each(function (data) {
    const multiMinWidth = getComputedStyle(this).getPropertyValue('--multi-select-input-min-width')

    let control = d3.select(this)
                      .selectAll('.select-control')
                      .data(function (d) {
                        return [d]
                      })
      , enter = control.enter()
                         .append('div')
                           .attr('class', 'select-control')
                           .on('mousedown.select', pointerHandler(function (e) {
                             if (data.open && !data.closeOnClick) {
                               return
                             }

                             e.stopPropagation()

                             // combo boxes should allow mouse events to fire on the input. See impact #35042
                             if (!data.combo) {
                               e.preventDefault() // So we don't end up focusing multiple times if the user clicks an element
                                                         // within the control window (e.g. the caret)
                             }


                             data.open ? interactions.close(data) : interactions.open(data)
                           }))
                           .on('mouseleave', function (e, d) {
                             if (d.open) {
                               d.emit('change:highlighted')
                             }
                           })
      , _control = enter.merge(control)

    enter.append('div')
           .attr('class', 'select-item')
           .on('mousedown.select', pointerHandler(function (e) {
             if (data.closeOnClick && !data.combo) { // See impact #35042, combo boxes should allow mouse events to continue
               e.preventDefault()
             }
           }))

    _control.call(caret)
            .selectAll('.select-item')
            .call(insert, 'select-item-before', data.render.itemBefore)
            .call(items)
            .call(input, _control.selectAll('.select-item .items .item').nodes()
                                 .map(function (item) {
                                   return d3.select(item).datum()
                                 }))
            .call(insert, 'select-item-after', data.render.itemAfter)
            .filter(function () {
              return data.multiple
            })
            .select(function () {
              // Set the input's textarea width based on how much space we have available
              // We can't do this inside of input.js, because we need to do it after the `select-item-after` has been applied.
              var textarea = d3.select(this).select('textarea')

              if (!textarea.size()) {
                return
              }

              var self = this
                , padding = parseFloat(textarea.style('padding-left')) + parseFloat(textarea.style('padding-right'))
                , lastItem = this.querySelector('.select-item .items .item:last-child')
                , childrenWidth = 0

              if (lastItem) {
                var lastRowTop = Math.floor(lastItem.getBoundingClientRect().top) // Floor in case top returns a long floating point number
                childrenWidth = [].reduce.call(this.querySelectorAll('.select-item .items .item'), function (p, c) {
                                                if (Math.floor(c.getBoundingClientRect().top) !== lastRowTop) {
                                                  // If this item isn't on the bottom row of the .select-items container (ie. where the cursor is positioned)
                                                  // then don't include it in the textarea calculation
                                                  return p
                                                }
                                                var style = window.getComputedStyle(c)
                                                return p +
                                                       (c.offsetWidth + 1) + // Add 1 because offsetWidth rounds
                                                       parseFloat(style.marginLeft) + parseFloat(style.marginRight) + // Margins
                                                       parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) // Paddings

                                              }, 0)
              }
              if (childrenWidth + parseInt(multiMinWidth) >= this.offsetWidth) {
                // If the width of the children + the min width of the textarea is great than the width of the parent
                // the textarea will be the first element on the next row, so it can have full width.
                childrenWidth = 0
              }
              textarea.style('width', `calc(100% - ${childrenWidth + padding}px)`)
            })

    if (data.autofocus) {
      this.querySelector('.select-control textarea').focus()
      delete data.autofocus // no mas
    }
  })
}

export default draw
